export default {
      id: "vk-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "sprite.svg#vk",
      toString: function () {
        return this.url;
      }
    }